// extracted by mini-css-extract-plugin
export var productHeader = "product-header_fbQjWHMITdgPuGHXNi5B";